(function () {
  'use strict';

  /** Swiper 9 loop needs roughly 2× the largest slidesPerView (4.2 on desktop). */
  var LOOP_MIN_SLIDES = 10;

  function resetLoopClones(wrapper) {
    if (!wrapper) return;
    wrapper.querySelectorAll('.swiper-slide[data-psc-clone]').forEach(function (node) {
      node.remove();
    });
  }

  function syncSlideA11y(wrapper) {
    if (!wrapper) return;
    wrapper.querySelectorAll('.swiper-slide').forEach(function (slide) {
      var isHidden =
        slide.getAttribute('aria-hidden') === 'true' ||
        slide.getAttribute('data-psc-clone') === 'true' ||
        slide.classList.contains('swiper-slide-duplicate');

      var focusableEls = slide.querySelectorAll(
        'a, button, input, select, textarea, [tabindex]'
      );

      focusableEls.forEach(function (el) {
        if (isHidden) {
          if (!el.hasAttribute('data-psc-orig-tabindex')) {
            var curr = el.getAttribute('tabindex');
            el.setAttribute('data-psc-orig-tabindex', curr !== null ? curr : '');
          }
          el.setAttribute('tabindex', '-1');
        } else {
          if (el.hasAttribute('data-psc-orig-tabindex')) {
            var orig = el.getAttribute('data-psc-orig-tabindex');
            el.removeAttribute('data-psc-orig-tabindex');
            if (orig !== '') {
              el.setAttribute('tabindex', orig);
            } else {
              el.removeAttribute('tabindex');
            }
          } else if (el.getAttribute('tabindex') === '-1') {
            el.removeAttribute('tabindex');
          }
        }
      });
    });
  }

  function prepareLoopSlides(wrapper) {
    if (!wrapper) return 0;

    resetLoopClones(wrapper);

    var originals = Array.prototype.slice.call(
      wrapper.querySelectorAll('.swiper-slide:not([data-psc-clone])')
    );
    var count = originals.length;
    if (count < 2) return count;

    var i = 0;
    while (count < LOOP_MIN_SLIDES) {
      var clone = originals[i % originals.length].cloneNode(true);
      clone.setAttribute('data-psc-clone', 'true');
      clone.setAttribute('aria-hidden', 'true');
      clone.querySelectorAll('a, button, input, select, textarea, [tabindex]').forEach(function (node) {
        node.setAttribute('tabindex', '-1');
      });
      wrapper.appendChild(clone);
      count++;
      i++;
    }

    return originals.length;
  }

  function initCarousel(root) {
    if (!root || root.dataset.pscReady === 'true') return;

    var el = root.querySelector('[data-psc-swiper]');
    if (!el || typeof Swiper === 'undefined') return;

    var wrapper = el.querySelector('.swiper-wrapper');
    var sourceCount = prepareLoopSlides(wrapper);
    if (sourceCount < 1) return;

    if (el.swiper && typeof el.swiper.destroy === 'function') {
      el.swiper.destroy(true, true);
    }

    root.dataset.pscReady = 'true';

    var swiper = new Swiper(el, {
      slidesPerView: 4.2,
      spaceBetween: 44,
      speed: 700,
      loop: sourceCount > 1,
      loopAdditionalSlides: Math.max(sourceCount, 4),
      loopPreventsSliding: false,
      grabCursor: true,
      watchOverflow: false,
      observer: true,
      observeParents: true,
      navigation: {
        prevEl: root.querySelector('[data-psc-prev]'),
        nextEl: root.querySelector('[data-psc-next]')
      },
      on: {
        init: function () {
          syncSlideA11y(wrapper);
        },
        slideChange: function () {
          syncSlideA11y(wrapper);
        },
        resize: function () {
          syncSlideA11y(wrapper);
        },
        observerUpdate: function () {
          syncSlideA11y(wrapper);
        }
      },
      breakpoints: {
        0: {
          slidesPerView: 1.15,
          spaceBetween: 20
        },
        576: {
          slidesPerView: 2.15,
          spaceBetween: 28
        },
        768: {
          slidesPerView: 2.5,
          spaceBetween: 36
        },
        992: {
          slidesPerView: 3,
          spaceBetween: 32
        },
        1200: {
          slidesPerView: 3,
          spaceBetween: 36
        },
        1440: {
          slidesPerView: 4.2,
          spaceBetween: 44
        }
      }
    });

    syncSlideA11y(wrapper);

    if (window.MutationObserver && wrapper) {
      var mo = new MutationObserver(function () {
        syncSlideA11y(wrapper);
      });
      mo.observe(wrapper, {
        attributes: true,
        subtree: true,
        attributeFilter: ['aria-hidden', 'class']
      });
    }
  }

  function initAll() {
    document.querySelectorAll('[data-product-showcases]').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target && event.target.querySelector
      ? event.target.querySelector('[data-product-showcases]')
      : null;
    if (section) {
      section.dataset.pscReady = 'false';
      initCarousel(section);
    } else if (event.target && event.target.matches && event.target.matches('[data-product-showcases]')) {
      event.target.dataset.pscReady = 'false';
      initCarousel(event.target);
    }
  });
})();
